import React from "react";
import SelectDivisoes from "../../DadosLojas/SelectDivisoes";
import SelectLojas from "../../DadosLojas/SelectLojas";
import SelectRegionais from "../../DadosLojas/SelectRegionais";
import Input from "../../Inputs";
import Select from "../../Select";
import factoryFields from "../../../helpers/factory-fields";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { actionGetGrupoMonitoramento } from "../../../features/grupos-de-monitoramento/slices";
import factoryOptionsFields from "../../../helpers/factory-fields";
import Checkbox from "../../Checkbox";
import Button from "../../Button";
import Modal from "../../Modal";
import { actionGetAlertasByFilter } from "../../../features/alertas/alertas-by-filter/slices";
import { EColorsStatus } from "../../../pages/Alertas/types";
import transformDate from "../../../helpers/transform-date";
import { actionGetRptAlertaDetalhe } from "../../../features/relatorios/rptAlertaDetalhe/slices";
import { actionGetRptAlertaLista } from "../../../features/relatorios/rptAlertaLista/slices";
import Alert from "../../Alert";
import { Filter, Calendar, Download, Loader2, Inbox } from "lucide-react";
import "./styles.scss";
import { getUser } from "../../../helpers/user";

interface IState {
  reportType: string;
  dataIni: string;
  dataFim: string;
  idDivisao: string;
  idRegional: string;
  idLoja: string;
  idGrupoMonitor: string;
  idEquipamento: string;
  manutencao: boolean;
}

const Actions = ({ close }) => (
  <nav className="actions">
    <Button size="sm" variant="secondary" onClick={close}>
      Fechar
    </Button>
  </nav>
);

const ContentModal = ({
  getAlertasByFilter,
  getRptAlertaDetalhe,
  reportType,
}) => {
  const user = getUser();
  const dispatch = useAppDispatch();
  const [loadingId, setLoadingId] = React.useState<number | null>(null);

  React.useEffect(() => {
    if (getRptAlertaDetalhe.status !== "loading") setLoadingId(null);
  }, [getRptAlertaDetalhe.status]);

  if (getAlertasByFilter.status === "loading") {
    return (
      <div className="alert-list__feedback">
        <Loader2 className="animate-spin" />
        <span>Carregando alertas...</span>
      </div>
    );
  }

  if (getAlertasByFilter.status === "error") {
    return <Alert type="error">Algo deu errado, tente novamente.</Alert>;
  }

  if (
    getAlertasByFilter?.data.length === 0 &&
    getAlertasByFilter.status === "success"
  ) {
    return (
      <div className="alert-list__feedback">
        <Inbox />
        <strong>Nenhum alerta encontrado</strong>
        <span>Tente ajustar o período ou remover algum filtro.</span>
      </div>
    );
  }

  const handleDownload = async (id: number) => {
    if (!reportType) {
      alert(
        "Por favor, selecione um formato de arquivo (XLSX, PDF...) antes de baixar.",
      );
      return;
    }
    setLoadingId(id);
    try {
      await dispatch(
        actionGetRptAlertaDetalhe({ idAlerta: id, reportType }),
      ).unwrap();
    } catch (error) {
      console.error("Erro ao baixar relatório:", error);
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className="alert-list">
      {getAlertasByFilter?.data
        ?.filter((alert: any) =>
          user.usuario.idRegional > 0
            ? alert.loja.idRegional === user.usuario.idRegional
            : alert,
        )
        .map((data: any) => (
          <div
            key={data.id}
            className={`alert-list__item ${EColorsStatus[data.status]}`}
          >
            <span className="alert-list__status-dot" aria-hidden="true" />
            <section className="description">
              <p>
                <strong>Alerta Nº {data.id}</strong>
              </p>
              <p>{data.descricao}</p>
              <p className="alert-list__date">
                <Calendar />
                {transformDate(data.dataEvento, true)}
              </p>
            </section>
            <nav>
              <Button
                loading={loadingId === data.id}
                disabled={loadingId !== null && loadingId !== data.id}
                variant="secondary"
                size="sm"
                onClick={() => handleDownload(data.id)}
              >
                <Download /> Baixar relatório
              </Button>
            </nav>
          </div>
        ))}
    </div>
  );
};

export const RptAlertaLista = () => {
  const dispatch = useAppDispatch();
  const [state, setState] = React.useState<IState>({
    reportType: "xlsx",
    dataIni: "",
    dataFim: "",
    idDivisao: "",
    idRegional: "",
    idLoja: "",
    idGrupoMonitor: "",
    idEquipamento: "",
    manutencao: false,
  });
  const [openModal, setOpenModal] = React.useState(false);

  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);

  const {
    getGrupoMonitoramento,
    getAlertasByFilter,
    getRptAlertaDetalhe,
    getRptAlertaLista,
  } = useAppSelector((state) => state);

  const handlerChange = ({
    target: { name, value, checked, type },
  }: React.ChangeEvent<any>) => {
    setState({ ...state, [name]: type === "checkbox" ? checked : value });
  };

  const handlerOpenModal = () => {
    setOpenModal(true);
    dispatch(
      actionGetAlertasByFilter({
        ...state,
        idLoja: lojaSelected ? String(lojaSelected) : "",
      }),
    );
  };

  React.useEffect(() => {
    dispatch(actionGetGrupoMonitoramento());
  }, []);

  return (
    <div className="filtro-alertas card">
      <header className="filtro-alertas__header">
        <Filter />
        <div>
          <h3 className="heading--sm">Filtrar alertas</h3>
          <p>
            Deixe os campos em branco para ver todos os alertas, ou preencha
            para restringir a busca por período, loja, regional ou grupo.
          </p>
        </div>
      </header>

      <div className="row mb-20">
        <div className="col-sm-12 col-md-3">
          <Checkbox
            onChange={handlerChange}
            name="manutencao"
            checked={state.manutencao}
            label="Somente em manutenção"
            size="sm"
            id="manutencao"
          />
        </div>
      </div>

      <div className="row mb-20">
        <div className="col-sm-12 col-md-3">
          <Input
            type="date"
            size="sm"
            label="Data início"
            name="dataIni"
            onChange={handlerChange}
          />
        </div>
        <div className="col-sm-12 col-md-3">
          <Input
            type="date"
            size="sm"
            label="Data fim"
            name="dataFim"
            onChange={handlerChange}
          />
        </div>
      </div>

      <div className="row mb-20">
        <div className="col-sm-12 col-md-3">
          <SelectDivisoes
            onChange={handlerChange}
            idDivisao={state.idDivisao}
          />
        </div>
        <div className="col-sm-12 col-md-3">
          <SelectRegionais
            onChange={handlerChange}
            idRegional={state.idRegional}
          />
        </div>
        <div className="col-sm-12 col-md-3">
          <SelectLojas />{" "}
          {/* Sem props de idLoja nem onChange, usa o fluxo padrão do Redux */}
        </div>
        <div className="col-sm-12 col-md-3">
          <Select
            options={
              getGrupoMonitoramento.data
                ? factoryOptionsFields.grupoMonitoramento(
                    getGrupoMonitoramento.data,
                  )
                : []
            }
            label="Grupos de monitoramento"
            name="idGrupoMonitor"
            onChange={handlerChange}
            value={state.idGrupoMonitor}
            size="sm"
          />
        </div>
      </div>

      <Button size="sm" onClick={handlerOpenModal}>
        Ver alertas
      </Button>

      {openModal && (
        <Modal
          overflow={true}
          header={
            <h3 className="heading--sm">
              Alertas - Loja {state.idLoja || "todas"}
            </h3>
          }
          actions={<Actions close={() => setOpenModal(false)} />}
        >
          <div className="content-modal-alertas">
            <div className="content-modal-alertas__header">
              <Select
                size="sm"
                name="reportType"
                label="Formato do arquivo para baixar"
                options={factoryFields.typesReport}
                value={state.reportType}
                onChange={handlerChange}
              />
              <Button
                loading={getRptAlertaLista.status === "loading"}
                variant="secondary"
                size="sm"
                onClick={() => dispatch(actionGetRptAlertaLista(state))}
              >
                <Download /> Baixar lista completa
              </Button>
            </div>
            <ContentModal
              getAlertasByFilter={getAlertasByFilter}
              getRptAlertaDetalhe={getRptAlertaDetalhe}
              reportType={state.reportType}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};
